<template>
    <div>
        <b-btn variant="primary" @click="$router.push({ name: 'clientsPage' })">
            <i class="fa fa-arrow-left"></i>
        </b-btn>
        <b-tabs v-if="theClient" v-model="indexTab">
            <b-tab title="Hoja de vida">
                <br />
                <app-client-card :the-client="theClient" />
            </b-tab>
            <b-tab title="Puestos" lazy v-if="!client.prospect">
                <br />
                <app-client-service-spots :the-client="theClient" />
            </b-tab>
            <b-tab title="Contactos" lazy>
                <br />
                <app-contacts-page :the-client="theClient" />
            </b-tab>
            <b-tab title="Reuniones" lazy>
                <br />
                <app-contact-reports-page :the-client="theClient" />
            </b-tab>
            <b-tab title="Sedes" lazy>
                <br />
                <app-venues-page :the-client="theClient" />
            </b-tab>
            <b-tab title="Minutas" lazy v-if="!client.prospect">
                <br />
                <app-notebook-page :the-client="theClient" />
            </b-tab>
            <b-tab
                title="Recomendaciones de seguridad"
                lazy
                v-if="!client.prospect"
            >
                <br />
                <app-safety-recommendations :the-client="theClient" />
            </b-tab>
            <b-tab title="Análisis de seguridad" lazy v-if="!client.prospect">
                <br />
                <app-risk-analysis :the-client="theClient" />
            </b-tab>
            <b-tab
                lazy
                title="Encuestas de satisfacción"
                v-if="userCan('encuesta-de-satisfaccion') && !client.prospect"
            >
                <br />
                <app-satisfaction-poll :the-client="theClient" />
            </b-tab>
            <b-tab title="Estrategia comercial" v-if="tabProspect" lazy>
                <br />
                <app-client-prospect-card
                    :the-prospect="theProspect"
                ></app-client-prospect-card>
            </b-tab>
            <b-tab title="Gestión documental" lazy>
                <br />
                <app-file-management-page></app-file-management-page>
            </b-tab>
            <b-tab title="Control de Puertas" lazy>
                <br />
                <app-doors-manager :the-client="client"></app-doors-manager>
            </b-tab>
            <b-tab title="Diagnostico de riesgos" lazy>
                <br />
                <app-risk-diagnosis :the-client="client"></app-risk-diagnosis>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import ClientCard from '../ClientCard/ClientCard.vue'
import ContactsPage from './Contacts/ContactsPage.vue'
import ContactReportsPage from './ContactReports/ContactReportsPage.vue'
import VenuesPage from '../Venues/VenuesPage.vue'
import NotebookPage from '../../Vigilance/NoteBook/NoteBookPage/NoteBookPage.vue'
import SafetyRecommendations from '../../Vigilance/SafetyRecommendations/SafetyRecommendations.vue'
import RiskAnalysis from '../RiskAnalysis/RiskAnalysis.vue'
import SatisfactionPoll from './ContactReports/SatisfactionPoll/SatisfactionPollPage.vue'
import ClientServiceSpots from './ClientServiceSpots/ClientServiceSpots'
import ClientProspectCard from '../../ClientCommercial/ClientProspectCard/ClientProspectCard'
import FileManagementPage from '../../Administrative/FileManagement/FileManagementPage'
import appDoorsManager from '../../Vigilance/AccessControl/DoorsManager/DoorsManager'
import RiskDiagnosis from '../RiskDiagnosis/RiskDiagnosisPage'

export default {
    components: {
        appClientCard: ClientCard,
        appContactsPage: ContactsPage,
        appContactReportsPage: ContactReportsPage,
        appVenuesPage: VenuesPage,
        appNotebookPage: NotebookPage,
        appSafetyRecommendations: SafetyRecommendations,
        appRiskAnalysis: RiskAnalysis,
        appSatisfactionPoll: SatisfactionPoll,
        appClientServiceSpots: ClientServiceSpots,
        appClientProspectCard: ClientProspectCard,
        appFileManagementPage: FileManagementPage,
        appDoorsManager,
        appRiskDiagnosis: RiskDiagnosis
    },

    props: ['clientId', 'prospect', 'prospectId', 'tabIndex'],

    data() {
        return {
            theClient: '',
            theProspect: {},
            flagProspect: false,
            idProspect: 0,
            indexTab: 0,
        }
    },
    computed: {
        tabProspect() {
            return !!this.client.prospect
        },
    },
    methods: {
        async loadClient() {
            const { data } = !this.client.prospect
                ? await repo.get(`clients/${this.clientId}`)
                : await repo.get(`clients/${this.clientId}`, {
                      prospect: true,
                  })
            this.$store.commit('client', data)
            this.theClient = data
            this.theProspect = data.client_commercial_info
        },
    },
    beforeMount() {
        this.indexTab = this.tabIndex ? this.tabIndex : 0
        this.loadClient()
    },
}
</script>
